import { useMutation, useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import * as requests from './requests'
import { TValidateRecipeAccessErrorData, TValidateRecipeAccessRequest, TValidateRecipeAccessSuccess } from './types'

export const KEY_GET_BASE_RECIPE = 'KEY_GET_BASE_RECIPE'

export const useGetBaseRecipe = (token: string) =>
  useQuery({
    queryKey: [KEY_GET_BASE_RECIPE, token],
    queryFn: () => requests.getBaseRecipe(token),
    enabled: !!token,
    retry: false,
    refetchOnWindowFocus: false
  })

export const useValidateRecipeAccess = (token: string) =>
  useMutation<TValidateRecipeAccessSuccess, AxiosError<TValidateRecipeAccessErrorData>, TValidateRecipeAccessRequest>({
    mutationFn: (payload: TValidateRecipeAccessRequest) => requests.validateRecipeAccess(token, payload)
  })
